import type { CollectionsApi } from '@fourthwall/services/dist/CollectionsApiClient/models'

type CollectionTimeFrame = CollectionsApi.GetCollection.Response['timeFrame']

type CollectionTimeFrameFrom = Extract<CollectionTimeFrame, { '@type': 'TIME_FRAME_FROM' }>

type CollectionTimeFrameTo = Extract<CollectionTimeFrame, { '@type': 'TIME_FRAME_TO' }>

type CollectionTimeFrameRange = Extract<CollectionTimeFrame, { '@type': 'TIME_FRAME_RANGE' }>

type CollectionTimeFrameNone = Extract<CollectionTimeFrame, { '@type': 'TIME_FRAME_NONE' }>

export const isTimeFrameFrom = (
  timeFrame: CollectionTimeFrame,
): timeFrame is CollectionTimeFrameFrom => {
  return timeFrame['@type'] === 'TIME_FRAME_FROM'
}

export const isTimeFrameTo = (
  timeFrame: CollectionTimeFrame,
): timeFrame is CollectionTimeFrameTo => {
  return timeFrame['@type'] === 'TIME_FRAME_TO'
}

export const isTimeFrameRange = (
  timeFrame: CollectionTimeFrame,
): timeFrame is CollectionTimeFrameRange => {
  return timeFrame['@type'] === 'TIME_FRAME_RANGE'
}

export const isTimeFrameNone = (
  timeFrame: CollectionTimeFrame,
): timeFrame is CollectionTimeFrameNone => {
  return timeFrame['@type'] === 'TIME_FRAME_NONE'
}
